import {
  CanDownloadContext,
  CanGenerateByOneflowContext,
  CanPreviewContext,
  CanSendToOneflowContext,
  GetOneflowTemplateIdContext,
  IConsultantContractStrategy
} from "../consultant-contract-strategy";

export class BcIntermittentContractStrategy implements IConsultantContractStrategy {
  public readonly name = "BcIntermittentContractStrategy";

  canPublishToOneflowDirectly(ctx: CanSendToOneflowContext): boolean {
    return false;
  }

  canPublishToOneflowViaTicket(ctx: CanSendToOneflowContext): boolean {
    return false;
  }

  getOneflowTemplateId(ctx: GetOneflowTemplateIdContext) {
    if (ctx.env === "dev" || ctx.env === "staging") {
      return {
        workspaceId: "419741",
        templateId: "5857853"
      };
    }

    if (ctx.env === "production") {
      return {
        workspaceId: "421117",
        templateId: "5777287"
      };
    }

    throw new Error("unknown env");
  }

  getOneflowGeneratorType(ctx: CanGenerateByOneflowContext) {
    return null;
  }

  canDuplicate(): boolean {
    return true;
  }

  canEdit(): boolean {
    return true;
  }

  canPreview(ctx: CanPreviewContext): boolean {
    return true;
  }

  canDownload(ctx: CanDownloadContext): boolean {
    return !!ctx.fileId
  }

  defaultSalaryChoice(): null {
    return null;
  }
}
